



















import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { startOfMonth, endOfMonth } from "date-fns";

import FormField from "@/layouts/DashboardLayoutComponents/FormField.vue";

import shiftModel from "@/models/shift.model";
import unitModel from "@/models/unit.model";
import userModel from "@/models/user.model";
import shiftKindModel from "@/models/shiftKind.model";

@Component({
	components: {
		FormField,
	},
})
class ShiftFilter extends Vue {
	@Prop({ default: true }) filterDates: boolean;
	@Prop({ default: true }) filterUnits: boolean;
	@Prop({ default: false }) filterMonth: boolean;
	@Prop({ default: true }) filterSpecialty: boolean;
	@Prop({ default: true }) filterSector: boolean;
	@Prop({ default: true }) filterProfessional: boolean;
	@Prop({ default: true }) filterState: boolean;
	@Prop({ default: true }) filterKind: boolean;
	@Prop({ default: false }) filterTotalType: boolean;
	@Prop({ default: true }) allowAllUnits: boolean;
	@Prop() statesToFilter: string[];

	unitModel: any;
	userModel: any;
	shiftKindModel: any;

	monthIndex: Record<string, number> = {
		jan: 0,
		feb: 1,
		mar: 2,
		apr: 3,
		may: 4,
		jun: 5,
		jul: 6,
		aug: 7,
		sep: 8,
		oct: 9,
		nov: 10,
		dec: 11,
	}

	monthOptions = [
		{name: "Janeiro", value: "jan"},
		{name: "Fevereiro", value: "feb"},
		{name: "Março", value: "mar"},
		{name: "Abril", value: "apr"},
		{name: "Maio", value: "may"},
		{name: "Junho", value: "jun"},
		{name: "Julho", value: "jul"},
		{name: "Agosto", value: "aug"},
		{name: "Setembro", value: "sep"},
		{name: "Outubro", value: "oct"},
		{name: "Novembro", value: "nov"},
		{name: "Dezembro", value: "dec"},
	]

	filterSchema: any[] = [
		{ name: "Data início", key: "startDate", kind: "date" },
		{ name: "Data fim", key: "endDate", kind: "date" },
		{ name: "Tipo do valor", key: "totalKind", kind: "select", options: [{ name: "Bruto", value: "gross" }, { name: "Líquido", value: "net" }] },
		{ name: "Unidade de saúde", key: "unit", kind: "relation", relationType: "many-to-one" },
		{ name: "Especialização", key: "specialty", kind: "relation", relationType: "many-to-one" },
		{ name: "Setor", key: "sector", kind: "relation", relationType: "many-to-one" },
		{ name: "Profissional", key: "user", kind: "relation", relationType: "many-to-one" },
		{ name: "Tipo de plantão", key: "kind", kind: "relation", relationType: "many-to-one" },
		{ name: "Mês", key: "month", kind: "select", options: this.monthOptions },
	];
	specialtyOptions: any[] = [];
	sectorOptions: any[] = [];

	filterEntity: any = {
		"unit.id": null,
		"specialty.id": null,
		"sector.id": null,
		"user.id": null,
		startDate: startOfMonth(new Date()).toISOString(),
		endDate: endOfMonth(new Date()).toISOString(),
		"state": null,
		"totalKind": null,
		"kind": null,
		"month": null,
	};

	unit: any = { unitSectors: [] };

	startOfMonth: any = null
	endOfMonth: any = null

	constructor() {
		super();
		this.unitModel = unitModel;
		this.userModel = userModel;
		this.shiftKindModel = shiftKindModel
	}

	async beforeMount() {
		// load state filter
		const shiftSchema = await shiftModel.getDescription();
		const stateField = { ...shiftSchema.find((field: any) => field.key === "state") };
		if (this.statesToFilter) {
			stateField.options = [ ...stateField.options.filter((option: any) => this.statesToFilter.includes(option.value))];
			this.filterEntity.state = this.statesToFilter[0]; // select first state
		} else {
			stateField.options = [{ name: "Todos", value: null }, ...stateField.options];
		}
		this.filterSchema.push(stateField);
	}

	async updated() {
		if (!this.filterState) {
			const stateFieldPosition = this.filterSchema.findIndex((field: any) => {
				return field.key === "state"
			});
			console.log('stateFieldPosition', stateFieldPosition)
			if (stateFieldPosition > 0) {
				this.filterSchema.splice(stateFieldPosition, 1)
			}
		}
	}

	// -- Filters
	get userFilter() {
		if (this.filterEntity["sector.id"]) {
			return { "userSectors.sector": { $eq: this.filterEntity["sector.id"] } };
		}

		if (this.filterEntity["specialty.id"]) {
			return { "userSectors.sector.specialty": { $eq: this.filterEntity["specialty.id"] } };
		}

		return {};
	}

	get currentUnit() {
		return this.filterEntity["unit.id"];
	}
	@Watch("currentUnit")
	async unitSelected(unitId: any) {
		if (!unitId) {
			return;
		}
		this.unit = await unitModel.read(unitId, "unitSectors", ["userSectors", "coordinatedSectors"]);
		// gera lista de opções de especialização
		if (this.unit) {
			this.$emit("unitLoaded", this.unit)
		}
		const specialtiesObject = Object.fromEntries(this.unit.unitSectors.map((unitSector: any) => [unitSector["sector.specialty.id"], unitSector["sector.specialty.name"]])); // transformação de especialidade em objeto para remover repetições
		this.specialtyOptions = Object.entries(specialtiesObject).map(([id, name]) => ({ id, name })); // transformação do objeto em lista de opções
		this.specialtyOptions.unshift({ id: "", name: "Todas" }); // adiciona opção Todas
		this.filterEntity["specialty.id"] = ""; // seleciona opção Todas
	}

	get currentSpecialty() {
		return this.filterEntity["specialty.id"];
	}
	@Watch("currentSpecialty")
	async specialtySelected(specialtyId: any) {
		// gera lista de opções de setor
		this.sectorOptions = this.unit.unitSectors.filter((unitSector: any) => unitSector["sector.specialty.id"] == specialtyId).map((unitSector: any) => ({ id: unitSector["sector.id"], name: unitSector["sector.name"] })); // conversão implícita de tipos intencional, não trocar o ==
		this.sectorOptions.unshift({ id: "", name: "Todos" }); // adiciona opção Todos
		this.filterEntity["sector.id"] = ""; // seleciona opção Todos
	}

	get currentMonth() {
		return this.filterEntity["month"]
	}
	@Watch("currentMonth")
	async monthSelected(month: any) {
		if (month) {
			const dateForFilter = (new Date()).setMonth(this.monthIndex[month])
			if (dateForFilter) {
				this.filterEntity.startDate = startOfMonth(dateForFilter)
				this.filterEntity.endDate = endOfMonth(dateForFilter)
			}
		}
	}

	get shiftFilter() {
		return {
			unit: this.filterEntity["unit.id"] || undefined,
			"sector.specialty": this.filterEntity["specialty.id"] || undefined,
			sector: this.filterEntity["sector.id"] || undefined,
			professionalUser: this.filterEntity["user.id"] || undefined,
			startDateTime: { $gte: this.filterEntity.startDate || this.startOfMonth, $lte: this.filterEntity.endDate || this.endOfMonth },
			state: this.filterEntity.state || undefined,
			totalKind: this.filterEntity.totalKind || undefined,
			kind: this.filterEntity["kind.id"] || undefined,
			month: this.filterEntity["month"] || undefined,
			deletedAt: null,
		};
	}

	@Watch("shiftFilter", { deep: true })
	filterUpdated(newFilter: any, previousFilter: any) {
		if (JSON.stringify(newFilter) !== JSON.stringify(previousFilter)) {
			if (!this.filterDates && !this.filterMonth) {
				delete newFilter.startDateTime;
			}
			this.$emit('updated', newFilter);
		}
	}
}

export default ShiftFilter;
